// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { router } from "./router/index";
import BootstrapVue from "bootstrap-vue";
import { BASEURL } from "@/config/index";

import i18n from "@/plugins/i18n";
import VueDragDrop from "vue-drag-drop";
import ProgressBar from "vuejs-progress-bar";

import VeeValidate from "vee-validate";
import validationMessages from "vee-validate/dist/locale/en";
import es from "vee-validate/dist/locale/es";
import en from "vee-validate/dist/locale/en";

import Datepicker from "vuejs-datepicker";

import Toasted from "vue-toasted";
import Mixin from "@/util/utilMixin";
import Vuex from "vuex";
import VueLazyload from "vue-lazyload";
import vueDebounce from "vue-debounce";

import Tooltip from "@/components/UIElements/Tooltip.vue";
import DropdownInputSearch from "@/components/UIElements/DropdownInputSearch.vue";

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import VueTour from "vue-tour";
import VueHtmlToPaper from 'vue-html-to-paper';

import { initBackendAndElectronSocket } from "./socket.io/init";

require("vue-tour/dist/vue-tour.css");

Vue.use(VueTour);
Vue.use(ProgressBar);
const io = require("socket.io-client");

Sentry.init({
  dsn:
    "https://e9566e7a535c42b3b094f33436aa779d@o424436.ingest.sentry.io/5356215",
  integrations: [
    new VueIntegration({ Vue, attachProps: true, logErrors: true })
  ]
});

// not required, to be deleted and tested
import axios from "axios";
import VModal from "vue-js-modal";
import VueCookie from "vue-cookie";
import headMixin from "@/util/head";
let originNew=window.location.origin

Vue.use(VueCookie);
Vue.component("Tooltip", Tooltip);
Vue.component("DropdownInputSearch", DropdownInputSearch);
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    `${originNew}/static/html2Pdf.css`
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}

Vue.use(VueHtmlToPaper, options);
Vue.use(VueHtmlToPaper);

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

// DRAG AND DROP USER JOURNEY
// import SimpleFlowchart from 'vue-simple-flowchart';
// import 'vue-simple-flowchart/dist/vue-flowchart.css';

// ALL STYLES
// import './assets/css/animate.min.css'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "../node_modules/slick-carousel/slick/slick.css";
import "./assets/css/slick-theme.css";
import "./assets/css/style.css";
import "./assets/css/button.css";
import "./assets/css/icons.css";
import "./assets/css/installation.css";
import "./assets/css/akash.css";
import "./assets/css/theme.css";
import "./assets/css/mobileDashboard.css";
import Multiselect from "vue-multiselect";

// import Hotjar from 'vue-hotjar'

// Vue.use(Hotjar, {
//   id: '1803449' // Hotjar Site ID
// })
import VuePivottable from "vue-pivottable";
import "vue-pivottable/dist/vue-pivottable.css";
Vue.use(VuePivottable);
// Filter
import "./filters/filters";

import VueMaterialIcon from "vue-material-icon";

Vue.component(VueMaterialIcon.name, VueMaterialIcon);

import VueClipboard from "vue-clipboard2";

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

/**
 * DATE TIME
 */
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
Vue.component("datetime", Datetime);
/**
 * DATE TIME
 */

Vue.use(Toasted, {
  duration: 4000,
  position: "top-center",
  singleton: true,
  containerClass: "toast-message"
});

import VueSocketIO from "vue-socket.io";

let url = "";
if (window.location.hostname == "192.168.1.189") {
  console.log("fsdfsdfsdf");
  url = "http://localhost:3001";
} else {
  url = "http://localhost:3001";
}
var myVar = my(url);

let socket_options = {
  reconnectionAttempts: 3,
  reconnectionDelay: 10000
};

function my(url) {
  axios
    .get(url)
    .then(response => {
      console.log("response :", response);
      if (response && response.status == "200") {
        Vue.toasted.show("Brij-POS Connect Successfully.");

        Vue.use(
          new VueSocketIO({
            debug: true,
            connection: url,
            options: socket_options
          })
        );
        myVar;
      }
    })
    .catch(err => {
      // console.log(err);
      Vue.use(
        new VueSocketIO({
          debug: true,
          connection: BASEURL + "/",
          options: socket_options
        })
      );
      // Vue.toasted.show('Unable to Connect Brij-POS')
    });
}

export const backendSocket = io(BASEURL + "/", socket_options);
export const electronSocket = io(url, socket_options);

initBackendAndElectronSocket(backendSocket, electronSocket);

//Current Code
// axios.get('http://localhost:3001').then(response => {
//   if (response && response.status == '200') {
//     console.log('response :', response);
//     Vue.toasted.show('Brij-POS Connect Successfully.')
//     Vue.use(new VueSocketIO({
//       debug: true,
//       connection: 'http://localhost:3001',
//     }))
//   }
// }).catch((err) => {
//   Vue.toasted.show('Unable to Connect Brij-POS')
// });

//Previous Code
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'http://localhost:3001',
// }))

// socketio
// import MyVuexStore from '@/socket.io/socket.io.js';
// import VueSocketIO from 'vue-socket.io';
// import { BASEURL } from "@/config/index";
// const SocketInstance = socketio(BASEURL);
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: BASEURL,
//   vuex: {
//     MyVuexStore
//   }
// }))
// End

// Import Store
import store from "./store";
Vue.component("Datepicker", Datepicker);
Vue.use(VModal);
Vue.component("multiselect", Multiselect);

import CustomMultiselect from "@/plugins/customMultiselect";
Vue.component("custommultiselect", CustomMultiselect);

Vue.use(BootstrapVue);
Vue.use(VueDragDrop);
Vue.use(Vuex);
Vue.use(Loading, {
  loader: "dots",
  color: "#007bff",
  width: 70,
  zIndex: 9999,
  height: 70,
  backgroundColor: "#4b4b4b"
});

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/placeholder-image.png",
  loading: "/static/placeholder-image.png",
  attempt: 1
});

Vue.use(vueDebounce);

Vue.use(BootstrapVue);
Vue.use(VueDragDrop);
// Vue.mixin(headMixin)
Vue.mixin(Mixin);

import english from "@/errorHandler/ln/en.js";
import spanish from "@/errorHandler/ln/es.js";

Vue.http = Vue.prototype.$http = axios;
Vue.config.productionTip = false;

export const EventBus = new Vue();
// Vue Vee Validate
// Vue.use(VeeValidate)

Vue.use(VeeValidate, {
  i18nRootKey: "validations", // customize the root path for validation messages.
  i18n,
  dictionary: {
    en: validationMessages
  },
  dictionary: {
    es: {
      messages: {
        ...es.messages,
        mobileOnly: "Эл.почта"
      },
      custom: spanish
    },
    en: {
      messages: {
        ...en.messages,
        mobileOnly: "mail test"
      },
      custom: english
    }
  }
});

VeeValidate.Validator.extend("mobileOnly", {
  validate: value => {
    return value === "123";
  }
});

import Vidle from "v-idle";

Vue.use(Vidle);

Vue.config.productionTip = false;

/* eslint-disable no-new */
global.vmVue = new Vue({
  i18n,
  el: "#app",
  store,
  router,
  components: {
    App
  },
  template: "<App/>"
});
global.VueMain = Vue;
// global.vmVue = new Vue({
//   i18n,
//   el: '#app',
//   store,
//   router,
//   components: {
//     App
//   },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js